<template src="./index.html"></template>

<script>
import genCore from '../index';
import Broker from './broker';
import componentsMixin from './componentsMixin';
export default {
    mixins: [genCore(true), Broker, componentsMixin],
    data: function() {
        return {
            theme: 'broker',
            mobileOutCom: false
        };
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.md-listing-search.broker {
    width: 100%;
    .more-keywords .tag-container {
        padding: 10px 10px 0 0px;
        background: #f3f3f3;
        border-radius: 5px;
        display: inline-block;
        max-width: 100%;
        .keywords-tag {
            display: inline-flex;
            margin-bottom: 10px;
            em {
                height: 26px;
                padding: 0 10px;
                background: #fff;
                border: 1px solid #d5d5d5;
                border-right: none;
                font: 14px var(--font-normal);
                line-height: 24px;
                color: #505050;
                margin-left: 10px;
            }
            .icon-wrap {
                width: 26px;
                height: 26px;
                border-radius: 0 5px 5px 0;
                background: #505050;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                .iconfont {
                    font-size: 12px;
                    color: #fff;
                }
            }
        }
    }
    .icon-arrow-down {
        margin-right: 10px;
    }
    .title_mid,
    .advance {
        font: 12px var(--font-medium);
        color: #505050;
    }

    .append {
        font-family: var(--font-bold);
        @include media-800 {
            font-size: 12px;
        }
        @include media-min-800 {
            font-size: 14px;
        }
    }
    .fixed {
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 200;
    }
    .mobile-sticky {
        padding: 15px;
        background: #fff;
        box-shadow: 0 2px 10px 0 rgba(0, 10, 30, 0.1);
    }
    .search-area {
        position: fixed;
        bottom: 60px;
        left: 50%;
        transform: translateX(-50%);
        padding: 12px 20px;
        color: #191919;
        font: 14px var(--font-medium);
        z-index: 10;
        display: flex;
        flex-direction: row;
        white-space: nowrap;
        background: #fff;
        border-radius: 22px;
        align-items: center;
        box-shadow: 0 4px 10px 3px rgba(0, 10, 30, 0.1);
        .map {
            cursor: pointer;
        }
        .iconfont {
            font-display: 14px;
            margin-right: 6px;
        }
    }
}

.md-listing-search.broker {
    width: 100%;
    background-color: #fff;
    // z-index: calc(var(--level-subhigh) - 3);
    &.onlymap,
    &:not(.compose) {
        box-shadow: 0 2px 10px 0 rgba(0, 10, 30, 0.1);
    }
    &.compose:not(.onlymap) {
        position: absolute;
        top: 0;
        left: 0;
        z-index: calc(var(--level-medium) - 1);
        .search-content {
            border-bottom: 1px solid #dadada;
            padding: 0 50px 20px;
        }
    }

    .search-mobile {
        display: none;
    }
    .search-content {
        > .header {
            display: none;
        }
        .oper-btns {
            display: none;
        }
    }
    .input-container {
        @include placeholderMix(var(--font-bold), #c6c8d1);
        @include media-800 {
            @include placeholderMix(var(--font-normal), #ccc, '12px');
        }
    }
    /* 小于 800 */
    @include media-800 {
        .search-mobile {
            display: flex;
            // padding-bottom: 13px;
            background-color: #f8f9fd;
            .input-container {
                flex: 1;
                background-color: #fff;
                padding: 5px 41px 5px 10px;
                position: relative;
                height: 36px;
                overflow: hidden;

                .search-wrap {
                    width: 36px;
                    height: 36px;
                    background: var(--g-btn-background);
                    position: absolute;
                    right: 0px;
                    top: 0;
                    text-align: center;
                    line-height: 26px;
                    border-radius: 0 5px 5px 0;
                    z-index: 1;
                }
                .icon-search {
                    color: #fff;
                    font-size: 20px;
                    font-weight: bold;
                    vertical-align: text-top;
                }
                input {
                    border: none;
                    outline: none;
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 36px;
                    line-height: 16px;
                    margin: 0;
                    padding-left: 10px;
                    background-color: #f3f3f3;
                    z-index: 0;
                    border-radius: 5px;
                    @include ellipsis();
                }
            }
            .button-filter {
                margin-left: 10px;
                height: 36px;
                padding: 0 12px;
                font-size: 12px;
                line-height: 36px;
                @include color-button();
                font-family: var(--font-medium);
                position: relative;
                display: flex;
                .icon-filter {
                    font-size: 12px;
                    margin-right: 5px;
                    line-height: 36px;
                }
                .count {
                    position: absolute;
                    transform: scale(0.5);
                    top: -16px;
                    right: -16px;
                    width: 32px;
                    height: 32px;
                    border-radius: 50%;
                    border: 2px solid #fff;
                    background-color: #f0454c;
                    color: #fff;
                    font-size: 20px;
                    font-family: var(--font-medium);
                    line-height: 26px;
                    text-align: center;
                }
            }
            .button-layout {
                height: 36px;
                width: 36px;
                margin-left: 10px;
                border: 1px solid #ebecf1;
                background-color: #fff;
                text-align: center;
                line-height: 34px;
                .iconfont {
                    font-size: 12px;
                }
                &.search {
                    width: auto;
                    // padding: 0 10px;
                }
                &.mode,
                &.search {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border: none;
                    background-color: #fff;
                    border: 1px solid #dadada;
                    color: #191919;
                    font: 14px var(--font-medium);
                    border-radius: 5px;
                    padding: 0 10px;
                    width: auto;
                    .mode_desc:not(.no-margin) {
                        margin-right: 8px;
                    }
                    .squar {
                        flex-shrink: 0;
                        width: 20px;
                        height: 20px;
                        background: var(--g-btn-background);
                        color: #fff;
                        font: 14px var(--font-medium);
                        line-height: 20px;
                        border-radius: 4px;
                    }
                }
            }
            .keyword-search {
                position: fixed;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                z-index: var(--level-high);
                background-color: white;
            }
            &.search-bar {
                .button-filter {
                    background-color: white;
                    @include color-button-color();
                    width: 36px;
                    padding: 0;
                    border: 1px solid #ebecf1;
                    line-height: 34px;
                    .iconfont {
                        width: 100%;
                        margin: 0;
                        text-align: center;
                        font-size: 16px;
                    }
                }
                .button-layout:not(.no-button-layout) {
                    @include color-button();
                    border: none;
                    line-height: 36px;
                }
            }
        }
        .search-content {
            position: fixed;
            top: 0;
            width: 100%;
            height: 100%;
            right: 0;
            background-color: white;
            z-index: calc(var(--level-subhigh) - 3);
            transform: translate(100%);
            font-size: 14px;
            transition: -webkit-transform 0.3s ease, transform 0.3s ease;
            &.mobile-search {
                display: block;
            }
            &.show {
                transform: translate(0, 0);
                .scroll-zone {
                    /* overflow-y: auto; */
                    // overflow-x: hidden;
                    height: calc(100% - 121px);
                    // -webkit-overflow-scrolling: touch;
                }
            }
            &.more-display-none{
                display: none;
            }
            > .header {
                height: 60px;
                line-height: 60px;
                text-align: center;
                font-family: var(--font-medium);
                color: #000000;
                font-size: 18px;
                display: flex;
                border-bottom: 1px solid #e2e4ea;
                .back {
                    left: 0;
                    position: absolute;
                    font-size: 14px;
                    color: #818592;
                    padding: 0 15px;
                }
                .filters {
                    flex: 1 0 0;
                }
                .reset {
                    position: absolute;
                    top: 0;
                    right: 15px;
                    height: 60px;
                    line-height: 60px;
                    color: #515666;
                    font-size: 14px;
                    font-family: var(--font-normal);
                    .icon-reset {
                        margin-right: 10px;
                    }
                }
            }

            .oper-btns {
                display: block;
                position: fixed;
                bottom: 0;
                left: 0;
                width: 100%;
                background: #fff;
                display: flex;
                font-size: 14px;
                border-top: 1px solid #e2e4ea;
                .btn {
                    height: 60px;
                    line-height: 60px;
                    font-family: var(--font-medium);
                    flex: 1;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .iconfont {
                        margin-right: 10px;
                        font-size: 14px;
                    }
                    &.save-search {
                        background-color: white;
                        position: relative;
                        color: var(--g-btn-background);
                        &.disabled {
                            opacity: 0.5;
                        }
                    }
                    &.more-search {
                        background: var(--g-btn-background);
                        color: #fff;
                    }
                }
            }

            .save-alert-box {
                z-index: var(--level-subhigh);
                opacity: 1;
                position: absolute;
                bottom: 54px;
                transform: translate(-50%) scale(0.5);
                left: 50%;
                border-radius: 4px;
                background-color: rgba(0, 0, 0, 0.7);
                height: 60px;
                line-height: 60px;
                color: #fff;
                padding: 0 12px;
                font-size: 20px;
                white-space: nowrap;
                &::after {
                    content: '';
                    position: absolute;
                    top: 100%;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 0;
                    height: 0;
                    border-top: 15px solid rgba(0, 0, 0, 0.7);
                    border-left: 15px solid transparent;
                    border-right: 15px solid transparent;
                }
            }
        }
    }
}
</style>
